import axios from 'axios';
import { API_URL } from '@/config';

export default {

  list() {
    return axios.get(`${API_URL}/invoices`);
  },

  export() {
    window.open(`${API_URL}/invoices-export?extension=csv`, '_blank');
  },

  download(id) {
    return `${API_URL}/invoices/${id}/download`;
  },

};
